// Shared ElementSelect widget used by the class editor, enemy/world-boss
// editors and other pieces that need a live element picker. Reads the
// centralized list from useElements (backend gm_elements collection).

import { useElements } from "@/gm/useElements";

export default function ElementSelect({ label, value, onChange, testid }) {
  const elements = useElements();
  const cls = "w-full bg-[#0a0a0a] border border-[#333] px-2.5 py-1.5 text-xs text-[#E2DFD8] focus:border-[#B89C3A] outline-none";
  return (
    <label className="block">
      {label && <div className="font-mono text-[9px] tracking-widest uppercase text-[#8c8c8c] mb-1">{label}</div>}
      <select data-testid={testid} value={value ?? ""} onChange={e => onChange(e.target.value)} className={cls}>
        <option value="">— nessuno —</option>
        {elements.filter(el => el.active !== false).map(el => (
          <option key={el.key} value={el.key} style={{ color: el.color }}>{el.name}</option>
        ))}
      </select>
    </label>
  );
}
